// extracted by mini-css-extract-plugin
module.exports = {"root":"AttachmentCard_root__2-gAN","header":"AttachmentCard_header__2Hhsv","headerMain":"AttachmentCard_headerMain__3Qmra","headerActions":"AttachmentCard_headerActions__1aH8Q"};